import { PropertyDetailsPDFViewer } from '@/property-details/pdf-viewer';
import { useCallback, useState } from 'react';
import { ConstructedListingDetails } from './constructed-listing-details';

export function ListingsInfoMod(props) {
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [listingForPdf, setListingForPdf] = useState({});

  const showPdf = useCallback((listing) => {
    setListingForPdf({ id: listing.id, platform: listing.platform });
    setShowPdfModal(true);
  }, []);

  return (
    <>
      <ConstructedListingDetails
        setShowPdfModal={setShowPdfModal}
        showPdf={showPdf}
        currentPlatformListings={props.currentPlatformListings}
        unitType={props.unitType}
        rentalStructure={props.rentalStructure}
        platformIcons={props.platformIcons}
      />

      {showPdfModal && (
        <PropertyDetailsPDFViewer
          currentPlatform={listingForPdf.platform}
          listings={props.listings}
          listingId={listingForPdf.id}
          showPdfModal={showPdfModal}
          closePdfModal={() => setShowPdfModal(false)}
        />
      )}
    </>
  );
}
